import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/sequence-card/sequence-card.js';
      import {ObcSequenceCardSize, ObcSequenceCardTitleType, ObcSequenceCardProgressType, ObcSequenceCardState} from '@oicl/openbridge-webcomponents/dist/components/sequence-card/sequence-card.js';
import {SequenceValue, SequenceType, SequenceStyle} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';

      export interface Props {
     size?: ObcSequenceCardSize;
     titleType?: ObcSequenceCardTitleType;
     progressType?: ObcSequenceCardProgressType;
     state?: ObcSequenceCardState;
     fullWidth?: boolean;
     fullHeight?: boolean;
     horizontal?: boolean;
     showConnector?: boolean;
     hasLeadingIcon?: boolean;
     cardTitle?: string;
     subtitle?: string;
     hasTimeStamp?: boolean;
     timeLabel?: string;
     time?: string;
     hasContent?: boolean;
     hasActions?: boolean;
     progressLabel?: string;
     progressValue?: SequenceValue;
     leftTime?: string;
     indicatorTypeOverride?: SequenceType | undefined;
     indicatorStyleOverride?: SequenceStyle | undefined
   }

      
  
      export type {ObcSequenceCardSize, ObcSequenceCardTitleType, ObcSequenceCardProgressType, ObcSequenceCardState} from '@oicl/openbridge-webcomponents/dist/components/sequence-card/sequence-card.js';
export type {SequenceValue, SequenceType, SequenceStyle} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSequenceCard',
  props: {
    size: {},
    titleType: {},
    progressType: {},
    state: {},
    fullWidth: { type: Boolean },
    fullHeight: { type: Boolean },
    horizontal: { type: Boolean },
    showConnector: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    cardTitle: {},
    subtitle: {},
    hasTimeStamp: { type: Boolean },
    timeLabel: {},
    time: {},
    hasContent: { type: Boolean },
    hasActions: { type: Boolean },
    progressLabel: {},
    progressValue: {},
    leftTime: {},
    indicatorTypeOverride: {},
    indicatorStyleOverride: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-sequence-card',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})